import React, { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { DataView } from 'primereact/dataview';
import InternalResourceItem from './InternalResourceItem';
import InternalResourceDetail from './InternalResourceDetail';
import InternalResourceManager from './InternalResourceManager';
import RelatedResourcesManager from './RelatedResourcesManager';
import styles from "../../../../components/Display/Wrapper.module.scss";

function InternalResourcesPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const [internalResourceList, setInternalResourceList] = useState([]);
  const [internalResourceDetail, setInternalResourceDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [emptyPayload, setEmptyPayload] = useState(false);
  const { setActiveView, navigationContext } = useNavigationContext();
  const [loading, setLoading] = useState(false);
  const [relatedResourcesManagerIsOpen, setRelatedResourcesManagerIsOpen] = useState(false);
  const [externalResourceList, setExternalResourceList] = useState([]);
  const [selectedExternalResourceList, setSelectedExternalResourceList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [selectedEventList, setSelectedEventList] = useState([]);
  const [relatedEventsManagerIsOpen, setRelatedEventsManagerIsOpen] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchInternalResourceList();
  }, []);

  const fetchInternalResourceList = async () => {
    await privateFetch('GET', 'solarys', `/cu/${accountContext.id}/internal-resource/`).then(
      (res) => {
        setInternalResourceList(res);
      }
    );
  };

  const fetchInternalResourceDetail = async () => {
    await privateFetch(
      'GET',
      'solarys',
      `/cu/${accountContext.id}/internal-resource/${navigationContext.activeInternalResourceId}/`
    ).then((res) => {
      if (res) setInternalResourceDetail(res);
    });
  };

  const createInternalResource = async (resourceForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'solarys',
      `/cu/${accountContext.id}/internal-resource/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(resourceForm)
    ).then(() => {
      fetchInternalResourceList();
      setPanelIsOpen(false);
      setLoading(false);
      setInternalResourceDetail(undefined);
      setEmptyPayload(true);
    });
  };

  const updateInternalResource = async (resourceForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'solarys',
      `/cu/${accountContext.id}/internal-resource/${internalResourceDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(resourceForm)
    ).then(() => {
      fetchInternalResourceList();
      setPanelIsOpen(false);
      fetchInternalResourceDetail(internalResourceDetail.id);
      setLoading(false);
      setRelatedResourcesManagerIsOpen(false);
      setRelatedEventsManagerIsOpen(false);
    });
  };

  const deleteInternalResource = async (resource) => {
    await privateFetch(
      'DELETE',
      'solarys',
      `/cu/${accountContext.id}/internal-resource/${resource.id}/`,
      'La ressource interne a bien été supprimée'
    ).then(() => {
      fetchInternalResourceList();
      setInternalResourceDetail(undefined);
    });
  };

  const fetchExternalResourceList = async () => {
    await privateFetch('GET', 'solarys', `/cu/${accountContext.id}/external-resource/`).then(
      (res) => {
        setExternalResourceList(res);
      }
    );
  };

  const fetchEventList = async () => {
    await privateFetch('GET', 'solarys', `/cu/${accountContext.id}/event/`).then((res) => {
      setEventList(res);
    });
  };

  useEffect(() => {
    if (relatedResourcesManagerIsOpen === true) fetchExternalResourceList();
    else setExternalResourceList([]);
  }, [relatedResourcesManagerIsOpen]);

  useEffect(() => {
    if (relatedEventsManagerIsOpen === true) fetchEventList();
    else setEventList([]);
  }, [relatedEventsManagerIsOpen]);

  useEffect(() => {
    if (navigationContext.activeInternalResourceId) {
      fetchInternalResourceDetail();
    } else setInternalResourceDetail(undefined);
  }, [navigationContext.activeInternalResourceId]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
    setEmptyPayload(false);
  };

  useEffect(() => {
    if (internalResourceDetail) {
      setSelectedExternalResourceList(internalResourceDetail?.related_resources);
      setSelectedEventList(internalResourceDetail?.related_events);
    }
  }, [internalResourceDetail, relatedResourcesManagerIsOpen, relatedEventsManagerIsOpen]);

  const handleClickInternalResource = (resource) => {
    setActiveView("syinternalresource", resource, "activeInternalResourceId");
  };

  const handleUpdateRelatedResources = (resources) => {
    const resourcePayload = {
      ...internalResourceDetail,
      city: internalResourceDetail.city.id,
      public_list: internalResourceDetail.public_list?.map((p) => p.id),
      related_resources: selectedExternalResourceList?.map((r) => r.id),
      related_events: selectedEventList?.map((e) => e.id)
    };
    updateInternalResource(resourcePayload);
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };

  const goBackInternalResourceAction = {
    onClick: handleClickInternalResource,
    label: 'Retour à la liste'
  };

  const newInternalResourceAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une ressource',
    icon: 'pi-plus'
  };


  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Ressources internes"
        labelAction={handleClickInternalResource}
        actions={internalResourceDetail ? [goBackInternalResourceAction] : [changeLayoutAction, newInternalResourceAction]}
        detail={internalResourceDetail}>
        {internalResourceDetail ? (
          <InternalResourceDetail
            resource={internalResourceDetail}
            handleUpdateResource={handleOpenManager}
            handleDelete={deleteInternalResource}
            handleUpdateExternalResource={() => setRelatedResourcesManagerIsOpen(true)}
            handleUpdateEvent={() => setRelatedEventsManagerIsOpen(true)}
          />
        ) : (

          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {internalResourceList.map((internalResource, index) => (
                <InternalResourceItem
                  layout={layout}
                  key={index}
                  resource={internalResource}
                  handleClickResource={() => handleClickInternalResource(internalResource)}
                />))}
            </div>
          </div>
        )}
      </PageWrapper>
      <InternalResourceManager
        isOpen={panelIsOpen}
        resource={internalResourceDetail}
        emptyPayload={emptyPayload}
        setPanelIsOpen={setPanelIsOpen}
        setResourceDetail={setInternalResourceDetail}
        loading={loading}
        onCreate={createInternalResource}
        onUpdate={updateInternalResource}
      />
      <RelatedResourcesManager
        isOpen={relatedResourcesManagerIsOpen}
        onClose={() => setRelatedResourcesManagerIsOpen(false)}
        objects={externalResourceList}
        selectedObjects={selectedExternalResourceList}
        setSelectedObjects={setSelectedExternalResourceList}
        handleValidate={handleUpdateRelatedResources}
      />
      <RelatedResourcesManager
        isOpen={relatedEventsManagerIsOpen}
        onClose={() => setRelatedEventsManagerIsOpen(false)}
        objects={eventList}
        selectedObjects={selectedEventList}
        setSelectedObjects={setSelectedEventList}
        handleValidate={handleUpdateRelatedResources}
      />
    </div>
  );
}

export default InternalResourcesPage;
